import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-fondo px-6 text-center font-sans text-tinta">
          <div>
            <p className="font-serif text-2xl">Algo salió mal.</p>
            <a href="/" className="mt-4 inline-block rounded-full bg-chocolate px-6 py-2 text-crema">
              Recargar
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
